import { createLabeledMessages } from '../../../messageUtils';
const address = {
    address: 'address',
    mailingAddress: 'mailing address',
    place: 'place',
    city: 'city',
    street: 'street',
    village: 'village',
    villagePart: 'village part',
    postalCode: 'postal code',
    postalCode_short: 'ZIP',
    buildingNumber: 'building number',
    buildingNumber_short: 'Nr.',
    orientationNumber: 'orientation number',
    flatZone: 'flat zone',
    regionZone: 'region zone'
};
export default Object.assign({}, address, createLabeledMessages(address));
